import { IS_LIVE, API_BASE_URL } from './env';
import { API_ERROR_LOGS } from './api';

export const logError = (payload) => {
    if (!IS_LIVE) return;
    fetch(`${API_BASE_URL}${API_ERROR_LOGS}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    }).catch(() => {});
};

export const  formatToIndianCurrency =(amount)  => {
    if (isNaN(amount)) return "Invalid number";

    const formatter = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    return formatter.format(amount);
}


export const calculateFinal = (offer, price, mrp) => {
    if (isNaN(price) || price <= 0) return "Invalid price";
    // `price` from the API is already the final selling price — display it directly
    return formatToIndianCurrency(price);
};

